module.exports = __webpack_public_path__ + "static/media/ma.7719069a.svg";